// extracted by mini-css-extract-plugin
export var formContainer = "_h4-0";
export var message = "_h4-1";